import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { useAdminRedirect } from '../hooks/useAdminRedirection';
import { useQueryActions } from '../../../hooks/useQueryActions';

import { getMutation } from '@/lib/react-query/mutate';
import { getCurrentRelativeUrl } from '@/utils/authRedirect';

export const useLogout = () => {
  const navigate = useNavigate();
  const { clear } = useQueryActions();
  const { returnToMercuryOrigin, isInAdminPath } = useAdminRedirect();

  function serverLogout() {
    return getMutation({
      endpoint: 'logout',
      mutationOptions: {
        onSuccess: () => {
          clear();
          Sentry.setUser(null);
        },
      },
    });
  }

  function clientLogout() {
    if (isInAdminPath()) {
      returnToMercuryOrigin('login?skipPrecheck=1');
      return;
    }

    const redirect = encodeURIComponent(getCurrentRelativeUrl());
    navigate(`/login?redirect=${redirect}`, { replace: true, state: { avoidPrecheck: true } });
  }

  return {
    serverLogout,
    clientLogout,
  };
};
